/*
 * PDP mobile-before-images: relocate the judge.me review badge (which also
 * carries the price via price-review.js) above the product images on mobile.
 *
 * Content blocks flagged "Show before images on mobile" are server-rendered
 * into .product__mobile-before. The review badge is an app block, so it can't
 * be captured in Liquid — we move its DOM node here instead. Single instance,
 * so the price stays live-updating.
 */
(function () {
  var container = document.querySelector('.product__mobile-before');
  if (!container) return;

  var mq = window.matchMedia('(max-width: 749px)');
  var badge = null; // the .product__app-block wrapping the review badge
  var placeholder = null; // marks the badge's original spot for restore

  function findBadge() {
    var preview = document.querySelector('.jdgm-preview-badge, .jdgm-prev-badge');
    if (!preview) return null;
    return preview.closest('.product__app-block');
  }

  function sync() {
    if (!badge) return;

    if (mq.matches) {
      if (badge.parentNode === container) return;
      var title = container.querySelector('.product__title-wrapper');
      container.insertBefore(badge, title ? title.nextSibling : null);
    } else if (placeholder && placeholder.parentNode && badge.parentNode === container) {
      placeholder.parentNode.insertBefore(badge, placeholder);
    }
  }

  function init() {
    badge = findBadge();
    if (!badge) return false;
    placeholder = document.createComment('mobile-before-badge-anchor');
    badge.parentNode.insertBefore(placeholder, badge);
    sync();
    return true;
  }

  if (!init()) {
    var observer = new MutationObserver(function () {
      if (init()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync); // Safari < 14
  }
})();
